/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Art_FootInputs */

const en_svc_research_art_foot = /** @type {(inputs: Svc_Research_Art_FootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sources: company site, job board, registry`)
};

const lv_svc_research_art_foot = /** @type {(inputs: Svc_Research_Art_FootInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoti: uzņēmuma lapa, darba sludinājumi, reģistrs`)
};

/**
* | output |
* | --- |
* | "Sources: company site, job board, registry" |
*
* @param {Svc_Research_Art_FootInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_art_foot = /** @type {((inputs?: Svc_Research_Art_FootInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Art_FootInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_art_foot(inputs)
	return en_svc_research_art_foot(inputs)
});